import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'

const whiteList = ['/', '/about', '/login', '/register', '/forgot-password','/cultural-mall', '/art-trade', '/gift', '/heritage']

function isWhiteListed(path, name) {
  if (whiteList.includes(path) || name === 'NotFound') return true
  if (path.startsWith('/gift/')) return true
  return false
}

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 粤文购` : '粤文购'

  const hasToken = getToken()

  if (hasToken) {
    if (to.name === 'Login') {
      next({ name: 'Home' })
    } else {
      if (store.getters['user/userInfo']) {
        next()
      } else {
        try {
          await store.dispatch('user/getUserInfo')
          next()
        } catch {
          await store.dispatch('user/logout')
          next({ name: 'Login', query: { redirect: to.fullPath } })
        }
      }
    }
  } else {
    if (isWhiteListed(to.path, to.name)) {
      next()
    } else {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    }
  }
})
